//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import Radium from "radium";
// tool-tip imports
import { IProps, IState } from "./tool-tip.d";
import * as styles from "./tool-tip.styles";

//////////////////
// COMPONENT
//////////////////
@Radium
export class ToolTip extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hovered: false,
    };
  }

  private hover() {
    this.setState({ hovered: true });
  }

  private unHover() {
    this.setState({ hovered: false });
  }

  public render() {
    const { maxWidth } = this.props;
    const tipStyle: React.CSSProperties = {
      ...styles.tipText,
      maxWidth,
      visibility: this.state.hovered ? "visible" : "hidden",
    };
    const arrowStyle = styles.arrow;
    if (this.props.position === "left") {
      tipStyle.right = 0;
      arrowStyle.left = "auto";
      arrowStyle.right = 5;
    }

    return (
      <div style={styles.container}>
        <div onMouseEnter={this.hover.bind(this)} onMouseLeave={this.unHover.bind(this)}>
          {this.props.target}
          {/*
            im actually going to want this to be in the <body> tag to be on top of everything
            gonn have to figure out positioning logic
          */}
          <div style={tipStyle}>
            <div style={arrowStyle}></div>
            {this.props.tipText}
          </div>
        </div>
      </div>
    );
  }
}
